import React from "react";
import { NochatMain } from "./styles/NochatStyle";

const Nochat = () => {
  return <NochatMain>No chat to display</NochatMain>;
};

export default Nochat;
